import { LandingContent } from "./types";

export const lionsPrideLanding: LandingContent = {
  ctaText: "Apply to Lion's Pride",
  quickFacts: ["12-month cohort", "Member program", "Teach-it-forward"],
  whyHeading: "Why teams use Lion's Pride",
  why: "Leading people is the skill that makes everything else work — and it's the one most owners were never trained for. Lion's Pride moves leadership beyond instinctual reactions and into consistent, repeatable habits that hold up in both calm and chaos. Each month you receive a challenge, apply it with your team, then teach the framework using the included Leader Guide — creating compounding development across your whole organization.",
  advantages: [
    {
      title: "Monthly challenges",
      description:
        "Every month delivers a specific leadership challenge — difficult conversations, alignment, accountability, trust — applied in your real day-to-day.",
      includedNote: "12 months, monthly leadership frameworks",
    },
    {
      title: "Leader Guide",
      description:
        "You don't just learn the framework — you teach it. Each month comes with a Leader Guide to run the same session with your team.",
      includedNote: "Teach-it-forward Leader Guide included",
    },
    {
      title: "Led by Brandon Marshall",
      description:
        "20+ years of leadership experience — grew revenue from $3M to $15M over seven years and doubled revenue in his first year as GM.",
      includedNote: "Virtual + in-person workshop options",
    },
  ],
  featureChecklist: [
    "12 months, monthly leadership frameworks",
    "Teach-it-forward Leader Guide included",
    "Virtual + in-person workshop options",
    "Community of committed leaders",
  ],
  highlights: [
    {
      title: "Community of leaders",
      description:
        "A cohort of committed owners and managers at similar stages, working through the same challenges at the same time.",
    },
  ],
  steps: [
    {
      title: "Apply to a cohort",
      description:
        "Submit an application — we match by stage, role, and goals to a cohort starting in the next quarter.",
    },
    {
      title: "Receive monthly challenges",
      description:
        "Each month delivers a leadership challenge designed to apply directly in your day-to-day operations.",
    },
    {
      title: "Apply with your team",
      description:
        "Teach the framework using the included Leader Guide. Your team builds the same muscle alongside you.",
    },
    {
      title: "Compound the change",
      description:
        "12 months of reinforcement creates leadership habits that hold under pressure — and a team trained to do the same.",
    },
  ],
  testimonials: [
    {
      quote:
        "Brandon doesn't hand you a textbook — he hands you a habit. Twelve months in, my managers are leading the same conversations I used to have to lead myself.",
      initials: "BM",
      name: "Brandon Marshall",
      attribution: "Lion's Pride Coach · CertainPath",
      stats: [
        { label: "Years leading", value: "20+" },
        { label: "Co. growth driven", value: "$3M→$15M" },
      ],
    },
  ],
  faqs: [
    {
      question: "Who is Lion's Pride for?",
      answer:
        "Owners, GMs, and managers ready to lead at scale — particularly those stepping from doing the work to leading the work.",
    },
    {
      question: "What's the time commitment?",
      answer:
        "Roughly 2 hours of cohort time per month, plus the application time with your own team. The Leader Guide is built to fit into existing meeting rhythms.",
    },
    {
      question: "Is it virtual or in-person?",
      answer:
        "Cohorts run virtually with optional in-person workshops. Most members prefer the flexibility of virtual with periodic in-person deep work.",
    },
    {
      question: "Who is Brandon Marshall?",
      answer:
        "20+ years of leadership experience — grew revenue from $3M to $15M over seven years and doubled revenue in his first year as GM.",
    },
  ],
  closing: {
    heading: "Become the leader your team is waiting for",
    body: "Apply to a Lion's Pride cohort and start building the leadership habits that scale with your business.",
  },
};
